//
//
//
//
//
//
//
//
//
//
//
//

import HelloSign from "hellosign-embedded";
import SpinnerLoader from "@Shared/utils/preload";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ESignAddSignatureFieldsPage",
  props: {
    requestedData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      helloSignInstance: null
    };
  },
  computed: {
    isEdit() {
      var _this$requestedData$, _this$requestedData$$;
      return (_this$requestedData$ = this.requestedData[0]) == null ? void 0 : (_this$requestedData$$ = _this$requestedData$.value) == null ? void 0 : _this$requestedData$$.isEdit;
    },
    helloSignLocale() {
      if (this.$root.$i18n.locale === "fr-CA") {
        return HelloSign.locales.FR_FR;
      }
      return HelloSign.locales.EN_US;
    }
  },
  beforeDestroy() {
    this.close();
  },
  mounted() {
    this.loadHelloSign();
  },
  methods: {
    loadHelloSign() {
      const {
        url,
        clientId
      } = this.requestedData[0].value;
      this.$nextTick(() => {
        try {
          SpinnerLoader.start("#hellosign-iframe-container");
          this.helloSignInstance = new HelloSign({
            clientId
          });
          this.helloSignInstance.open(url, {
            // eslint-disable-next-line no-undef
            skipDomainVerification: process.env.ENVIRONMENT !== "production",
            allowCancel: true,
            container: this.$refs.iframeWrapper,
            locale: this.helloSignLocale
          });
          this.helloSignInstance.on("ready", () => SpinnerLoader.stop());
          this.helloSignInstance.on("send", ({
            signatureRequestInfo
          }) => {
            this.$emit("complete", signatureRequestInfo);
          });
          this.helloSignInstance.on("createTemplate", ({
            templateId
          }) => {
            this.$emit("finish-template", templateId, this.isEdit ? "Updated" : "Created");
          });
          this.helloSignInstance.on("cancel", () => {
            this.$emit("cancel");
          });
          this.helloSignInstance.on("error", error => {
            this.$emit("error", error);
          });
        } catch (error) {
          this.$emit("error", error);
        }
      });
    },
    close() {
      var _this$helloSignInstan;
      (_this$helloSignInstan = this.helloSignInstance) == null ? void 0 : _this$helloSignInstan.close();
    }
  }
});